// =============================================================================
//  Copyright   : 2023 semantics GmbH
//  Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 156393 $
//  Purpose     : sagas for vlm package
// =============================================================================
// ---Third-party imports
import {takeEvery} from 'redux-saga/effects'

// ---Framework imports
import log from 'uix/logging'

export const sagas = {
  setVlmState: takeEvery('SET_TO_VLM_STATE', function*({payload}) {
    let {name, value} = payload
    //log.x(name, value)
    globalThis.vlmhost?.tovlm(name, value)
  }),
}
